import * as React from 'react';
import { SVGProps } from 'react';

const SvgWalkIn = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M19.3 32V8H5.8v24"
    />
    <path fill="currentColor" d="m12 17.7 4.2-2.4v4.9L12 17.7z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M24 17.7h-7.8"
    />
    <path
      fill="currentColor"
      d="m26.2 20.3-.1.2-2.4 2.1-.9-.9 1.8-2.3 2.2-4.5 3.7-1 2.8 3.4.2.3v.2l.3 3.9-1.4.2-.6-3.5-1.1-1.1.1 1.6.9 3.2.3 4.1 2.7 4.9-1.6.9-3.1-4.9-.1-.3-.7-1.9-1.7 2.2-1.6 4.9-1.7-.5 1.2-5.1v-.1l.1-.3 1.8-3.9-.5-2.8-.6 1zm2.6-6.4c-.2.1-.5.2-.8.2-.9 0-1.5-.7-1.6-1.5v-.8c0-.6.3-1.1.8-1.4.2-.1.5-.2.8-.2.9 0 1.5.7 1.6 1.5v.8c0 .6-.3 1.1-.8 1.4z"
    />
    <path fill={props.fill} d="M5 32v-4h8l4 4H5z" />
  </svg>
);

export default SvgWalkIn;
